// extracted by mini-css-extract-plugin
export default {"container":"IP1Sj3zoYe","message-count":"kthKEUW5Dq","messageCount":"kthKEUW5Dq","icon":"VFsrVZ1lTa","messages":"ytYVRRYZwY","status":"_23fhsy4ZvU","date-time":"OJi72Xd4Gh","dateTime":"OJi72Xd4Gh"};
    if(module.hot) {
      // 1648553846041
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  